<template>
  <div>
    <header class="header">
      <div class="container">
        <svg
          class="logo"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="2921 2522 414.7 529.929"
        >
          <defs />
          <g id="Group_5" data-name="Group 5" transform="translate(2921 2520)">
            <path
              id="U"
              class="cls-1"
              d="M.927,265.792.312,140.516q0-18.444,20.9-18.444h80.538q12.3,0,19.059,4.918a15.813,15.813,0,0,1,6.763,13.525l2.459,111.751q.615,39.96,21.825,63.016t57.483,23.055q71.317,0,71.316-81.153l1.23-204.112q0-7.992,7.685-13.833A29.12,29.12,0,0,1,307.709,33.4h81.768q11.683,0,18.136,5.226t5.841,14.448v90.99q0,84.842.307,105.745t.307,22.133a247.1,247.1,0,0,1-16.907,94.371q-17.522,44.571-63.324,74.39T210.572,470.519q-70.7,0-117.733-28.9T23.367,366.311Q.927,319.9.927,265.792Z"
              transform="translate(0.61 61.41)"
            />
            <path
              id="Rectangle"
              class="cls-1"
              d="M73.779,2H283.637a14.78,14.78,0,0,1,14.779,14.779v91.628H73.779A14.779,14.779,0,0,1,59,93.628V16.779A14.779,14.779,0,0,1,73.779,2Z"
              transform="translate(115.389 0)"
            />
            <circle
              id="Oval"
              cx="62.071"
              cy="62.071"
              r="62.071"
              transform="translate(0 2)"
            />
          </g>
        </svg>

        <!--                <div id="add" class="tabs gallery mobile_tab" v-if="secondaryMenu">-->
        <!--                    <ul class="tab-links">-->
        <!--                        <li class="active">-->
        <!--                            <router-link :to="{name: 'concept_art'}">Concept Art</router-link>-->
        <!--                        </li>-->
        <!--                        <li>-->
        <!--                            <router-link :to="{name: 'color_grading'}">Marketing Creatives</router-link>-->
        <!--                        </li>-->
        <!--                        <li>-->
        <!--                            <router-link :to="{name: 'mix_media'}">Mix Media</router-link>-->
        <!--                        </li>-->
        <!--                        <li>-->
        <!--                            &lt;!&ndash;              <router-link :to="{name: 'social_media'}">Color Grading</router-link>&ndash;&gt;-->
        <!--                        </li>-->
        <!--                    </ul>-->
        <!--                </div>-->

        <nav class="nav-primary">
          <!-- <a href="#" class="nav-btn"></a> -->
          <a
            class="nav-btn"
            :class="{ open: this.menuVisibility }"
            @click="toggleMenu()"
          >
            <span></span>
            <span></span>
            <span></span>
          </a>
          <ul class="nav-list" :class="{ open: this.menuVisibility }">
            <li>
              <a class href="/"></a>
              <svg
                class="logo-mobile"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="2921 2522 414.7 529.929"
              >
                <defs />
                <g
                  id="Group_5"
                  data-name="Group 5"
                  transform="translate(2921 2520)"
                >
                  <path
                    id="U"
                    class="cls-1"
                    d="M.927,265.792.312,140.516q0-18.444,20.9-18.444h80.538q12.3,0,19.059,4.918a15.813,15.813,0,0,1,6.763,13.525l2.459,111.751q.615,39.96,21.825,63.016t57.483,23.055q71.317,0,71.316-81.153l1.23-204.112q0-7.992,7.685-13.833A29.12,29.12,0,0,1,307.709,33.4h81.768q11.683,0,18.136,5.226t5.841,14.448v90.99q0,84.842.307,105.745t.307,22.133a247.1,247.1,0,0,1-16.907,94.371q-17.522,44.571-63.324,74.39T210.572,470.519q-70.7,0-117.733-28.9T23.367,366.311Q.927,319.9.927,265.792Z"
                    transform="translate(0.61 61.41)"
                  />
                  <path
                    id="Rectangle"
                    class="cls-1"
                    d="M73.779,2H283.637a14.78,14.78,0,0,1,14.779,14.779v91.628H73.779A14.779,14.779,0,0,1,59,93.628V16.779A14.779,14.779,0,0,1,73.779,2Z"
                    transform="translate(115.389 0)"
                  />
                  <circle
                    id="Oval"
                    cx="62.071"
                    cy="62.071"
                    r="62.071"
                    transform="translate(0 2)"
                  />
                </g>
              </svg>
            </li>
            <li>
              <router-link
                class="nav-item"
                :to="{ name: 'ui/ux' }"
                @click.native="handleClick"
                >Home</router-link
              >
            </li>
            <li>
              <router-link class="nav-item" :to="{ name: 'About' }"
                >Get to Know Me</router-link
              >
            </li>

            <!--  <li> <router-link class="nav-item" :to="{ name: 'Work' }">What I do</router-link>
                        </li> -->

            <!--                        <li>-->
            <!--                            <a class="nav-item" href="/img/resume.pdf" download>-->
            <!--                                &lt;!&ndash;                <span class="new">Download</span>&ndash;&gt;-->
            <!--                                Resume-->
            <!--                            </a>-->
            <!--                        </li>-->

            <!-- <li><a class="nav-item" href="">Print &amp; Frame</a></li> -->
            <li>
              <a
                class="nav-item"
                href="mailto:hello@ujjwalverma.com"
                @click.native="handleClick"
                >Say Hello</a
              >
            </li>
            <li>
              <a
                href="/img/resume.pdf"
                target="_blank"
                class="nav-item"
                @click.native="handleClick"
                >Resume</a
              >
            </li>
            <li>
              <router-link
                class="nav-item"
                :to="{ name: 'Wallpapers' }"
                @click.native="handleClick"
                >Wallpapers</router-link
              >
            </li>
            <li>
              <a
                class="nav-item hero"
                href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=Up%20for%20chit%20chat?&add=ujjwallverma@gmail.com"
                @click.native="handleClick"
                >Schedule Meet-up <span>Open to work</span></a
              >

              <!--              <router-link class="nav-item" :to="{ name: 'Plans' }">Subscription</router-link>-->
            </li>
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuVisibility: false,
      secondaryMenu: false,
    };
  },
  watch: {
    $route(to) {
      this.menuVisibility = false;
      if (to.path.indexOf("show-off") !== -1) {
        this.secondaryMenu = true;
      } else {
        this.secondaryMenu = false;
      }
    },
  },
  methods: {
    toggleMenu() {
      this.menuVisibility = !this.menuVisibility;
    },
    handleClick() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    },
  },
};
</script>
